import { useMemo } from "react";

import { CampaignCardLabelValueI } from "shared/ui/cards/campaign-card/campaign-card-default";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { clsxMerge } from "shared/lib/helpers";

interface CampaignCardStatsPropsI extends PropsWithClassNameI {
  stats?: CampaignCardLabelValueI[];
  hideBasicStats?: boolean;
  statsClassName?: string;
}

export const CampaignCardStats = ({
  stats,
  hideBasicStats,
  className,
  statsClassName,
}: CampaignCardStatsPropsI) => {
  const accentStats = useMemo(() => stats?.filter((s) => s.accent), [stats]);
  const basicStats = useMemo(() => stats?.filter((s) => !s.accent), [stats]);

  return (
    <div className={clsxMerge("flex gap-2", className)}>
      <div
        className={clsxMerge(
          "flex gap-8 rounded-md bg-[#F2F5FC] p-3",
          statsClassName
        )}
      >
        {accentStats?.map((stat, i) => (
          <span key={i} className="ae-typography-body2">
            <p className="ae-typography-body3 mb-2">{stat.label}</p>
            <p>{stat.value}</p>
          </span>
        ))}
      </div>

      {!hideBasicStats && (
        <div className={clsxMerge("flex gap-8 p-3", statsClassName)}>
          {basicStats?.map((stat, i) => (
            <span key={i} className="ae-typography-body2">
              <p className="mb-2">{stat.label}</p>
              <p>{stat.value}</p>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
